export default {
  title: null,
  content: null,
  loading: false,
};
